<div class="offer-audience-form" *ngIf="audienceForm" [formGroup]="audienceForm">
  <h5 class="offer-section-title">Choose Target Audience</h5>
  <p class="offer-section-subtitle">
    Select a filter to target specific customers for this SMS offer. This step is optional.
  </p>

  <div class="audience-locked-note" *ngIf="isLocked">
    The target audience is set when the offer is created and cannot be changed afterward.
  </div>

  <div class="filter-cards-grid">
    <div
      *ngFor="let card of filterCards"
      class="filter-card"
      [ngClass]="{ 'filter-card--selected': isSelected(card.type), 'filter-card--locked': isLocked }"
      (click)="selectFilter(card.type)"
      role="button"
      [attr.aria-pressed]="isSelected(card.type)"
      [attr.aria-disabled]="isLocked"
    >
      <p-card>
        <div class="filter-card__content">
          <strong class="filter-card__label">{{ card.label }}</strong>
          <span class="filter-card__description">{{ card.description }}</span>
        </div>
      </p-card>
    </div>
  </div>

  <!-- Inline filter configuration -->
  <ng-container *ngIf="selectedFilter">
    <div class="all-consumers-info" *ngIf="selectedFilter === FilterType.AllConsumers">
      <p>This filter targets all enrolled consumers at this location. No additional configuration is required.</p>
    </div>
    <app-offer-audience-top-consumers-form
      *ngIf="selectedFilter === FilterType.TopConsumers"
      formGroupName="TopConsumersConfig"
    />
    <app-offer-audience-win-back-form *ngIf="selectedFilter === FilterType.WinBack" formGroupName="WinBackConfig" />
  </ng-container>

  <!-- Recalculate before sending -->
  <div class="audience-recalculate" *ngIf="selectedFilter">
    <label class="audience-recalculate__option">
      <input type="checkbox" formControlName="IsDynamicAudience" />
      <span>Recalculate before sending</span>
    </label>
  </div>

  <!-- Real-time customer count preview -->
  <div class="audience-preview" *ngIf="selectedFilter">
    <div class="audience-preview__loading" *ngIf="previewLoading$ | async">
      <p-progressSpinner [style]="{ width: '24px', height: '24px' }" strokeWidth="4"></p-progressSpinner>
      <span>Loading customer count...</span>
    </div>
    <div class="audience-preview__error" *ngIf="(previewError$ | async) && !(previewLoading$ | async)">
      Unable to load customer count. Please try again.
    </div>
    <div
      class="audience-preview__count"
      *ngIf="
        (previewCount$ | async) !== null &&
        (previewCount$ | async) !== 0 &&
        !(previewLoading$ | async) &&
        !(previewError$ | async)
      "
    >
      {{ previewCount$ | async }} customers match this filter
      <div class="audience-preview__dynamic-note" *ngIf="isDynamic">
        Estimated - the list is recalculated the day the SMS is sent, so this number may change.
      </div>
      <div class="audience-preview__dynamic-note" *ngIf="!isDynamic">This is the exact list that will be sent.</div>
      <div
        class="audience-preview__average-spend"
        *ngIf="selectedFilter === FilterType.TopConsumers && (previewAverageSpend$ | async) !== null"
      >
        These consumers spend an average of
        {{ previewAverageSpend$ | async | currency : 'USD' : 'symbol' : '1.2-2' }} in this period with these filters
      </div>
    </div>
    <div
      class="audience-preview__warning"
      *ngIf="(previewCount$ | async) === 0 && !(previewLoading$ | async) && !(previewError$ | async)"
    >
      No customers match these criteria
    </div>
  </div>
</div>
